
import * as asyncTreeApi from './compatible';

export default asyncTreeApi;
